import axios from 'axios'
import axiosRetry from 'axios-retry'

import { ADDRESSCLOUD_ENV } from '../constants'

// Configure retries
axiosRetry(axios, { retries: 3, retryDelay: axiosRetry.exponentialDelay })

/** Class representing auth service. */
export default class AuthAPI {

  /**
   * @description
   * Gets user profile from Auth service.
   */
  async getProfile() {
    try {
      const url = `https://${ADDRESSCLOUD_ENV}.addresscloud.com/auth/v1/profile/apps/batch`
      const resp = await axios.get(url, { mode: 'cors', headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}`}})
      return resp.data
    } catch(err) {
      console.error(err)
      throw err
    }
  }

  /**
   * @description
   * Gets user profile from Auth service.
   */
  async getKey() {
    try {
      const url = `https://${ADDRESSCLOUD_ENV}.addresscloud.com/auth/v1/key/apps`
      const resp = await axios.get(url, { mode: 'cors', headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}`}})
      return resp.data
    } catch(err) {
      console.error(err)
      throw err
    }
  }

}
